import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';

// URLs propias del backend (requieren token de sesión) — sumar acá cada nuevo
// apiUrls.xxx que necesite auth, en vez de repetir la comparación en cada feature.
const PROTECTED_API_URLS = [
  environment.apiUrls.accountService,
  environment.apiUrls.notificacionService,
  environment.apiUrls.profilePersonService
];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const isProtectedApi = PROTECTED_API_URLS.some(url => req.url.startsWith(url));
  const token = authService.getToken();

  const authReq = isProtectedApi && token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    catchError((err: HttpErrorResponse) => {
      if (isProtectedApi && err.status === 401) {
        authService.logout();
        router.navigate(['/login']);
      }
      return throwError(() => err);
    })
  );
};
